import React from "react";

import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Paper,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@material-ui/core";

import {
  Document,
  Page,
  pdfjs
} from "react-pdf";

import api
  from "../../services/api";


pdfjs.GlobalWorkerOptions.workerSrc =
  `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;


const clamp = (
  value,
  min,
  max
) =>
  Math.min(
    max,
    Math.max(
      min,
      value
    )
  );


const KoraxSignEditor = ({
  match
}) => {

  const documentId =
    Number(
      match?.params?.id
    );


  const [
    loading,
    setLoading
  ] =
    React.useState(true);

  const [
    saving,
    setSaving
  ] =
    React.useState(false);

  const [
    error,
    setError
  ] =
    React.useState("");

  const [
    success,
    setSuccess
  ] =
    React.useState("");

  const [
    documentData,
    setDocumentData
  ] =
    React.useState(null);

  const [
    pdfUrl,
    setPdfUrl
  ] =
    React.useState("");

  const [
    numPages,
    setNumPages
  ] =
    React.useState(0);

  const [
    pageNumber,
    setPageNumber
  ] =
    React.useState(1);

  const [
    pageWidth,
    setPageWidth
  ] =
    React.useState(760);

  const [
    pageRatio,
    setPageRatio
  ] =
    React.useState(1.414);

  const [
    field,
    setField
  ] =
    React.useState({
      page: 1,
      x: 0.17,
      y: 0.77,
      width: 0.32,
      height: 0.075
    });

  const [
    dirty,
    setDirty
  ] =
    React.useState(false);



  const [
    sending,
    setSending
  ] =
    React.useState(false);

  const [
    signingLink,
    setSigningLink
  ] =
    React.useState("");


  // KORAX SIGN V0.9 - Edicao do signatario
  const [editingSigner, setEditingSigner] =
    React.useState(false);

  const [savingSigner, setSavingSigner] =
    React.useState(false);

  const [signerForm, setSignerForm] =
    React.useState({
      name: "",
      email: "",
      phone: "",
      identityType: "CPF",
      identity: ""
    });

  const openSignerEditor = () => {
    const current = documentData?.signers?.[0];

    if (!current || current.signedAt ||
        current.status === "SIGNED" ||
        ["COMPLETED", "CANCELLED"].includes(
          documentData?.status
        )) {
      return;
    }

    setSignerForm({
      name: current.name || "",
      email: current.email || "",
      phone: current.phone || "",
      identityType: current.identityType || "CPF",
      identity: ""
    });

    setEditingSigner(true);
    setError("");
  };


  const saveSignerDetails = async () => {
    if (savingSigner || saving || sending) return;

    setSavingSigner(true);
    setError("");
    setSuccess("");

    try {
      const current = documentData?.signers?.[0];

      if (!current) {
        throw new Error("Signatário não encontrado.");
      }

      const payload = {
        name: signerForm.name.trim(),
        email: signerForm.email.trim(),
        phone: signerForm.phone.trim()
      };

      const type = signerForm.identityType || "CPF";
      const previousType = current.identityType || "CPF";

      if (type !== previousType && !signerForm.identity.trim()) {
        throw new Error(
          "Informe o número completo do novo CPF ou CNPJ."
        );
      }

      if (signerForm.identity.trim()) {
        payload.identityType = type;
        payload.identity = signerForm.identity.trim();
      }

      const response = await api.patch(
        `/korax-sign/documents/${documentId}/signer`,
        payload
      );

      const detailResponse = await api.get(
        `/korax-sign/documents/${documentId}`
      );

      applyDocument(detailResponse.data.document || detailResponse.data);

      setSigningLink("");
      setEditingSigner(false);
      setSignerForm(currentForm => ({
        ...currentForm,
        identity: ""
      }));

      setSuccess(
        response.data.message ||
        "Dados atualizados com sucesso."
      );

    } catch (err) {
      setError(
        err?.response?.data?.message ||
        err?.message ||
        "Não foi possível atualizar o signatário."
      );
    } finally {
      setSavingSigner(false);
    }
  };


  const viewportRef =
    React.useRef(null);

  const urlRef =
    React.useRef("");

  const interactionRef =
    React.useRef(null);


  const applyDocument =
    React.useCallback(
      data => {

        setDocumentData(
          data
        );


        const signer =
          data?.signers?.[0];


        if (
          signer?.fieldPage &&
          signer?.fieldX !== null &&
          signer?.fieldX !== undefined &&
          signer?.fieldY !== null &&
          signer?.fieldY !== undefined &&
          signer?.fieldWidth !== null &&
          signer?.fieldWidth !== undefined &&
          signer?.fieldHeight !== null &&
          signer?.fieldHeight !== undefined
        ) {

          const nextField = {
            page:
              Number(
                signer.fieldPage
              ),

            x:
              Number(
                signer.fieldX
              ),

            y:
              Number(
                signer.fieldY
              ),

            width:
              Number(
                signer.fieldWidth
              ),

            height:
              Number(
                signer.fieldHeight
              )
          };


          setField(
            nextField
          );

          setPageNumber(
            nextField.page
          );
        }
      },
      []
    );


  React.useEffect(
    () => {

      let mounted =
        true;


      const load =
        async () => {

          setLoading(
            true
          );

          setError("");


          try {

            const [
              detailResponse,
              pdfResponse
            ] =
              await Promise.all([

                api.get(
                  `/korax-sign/documents/${documentId}`
                ),

                api.get(
                  `/korax-sign/documents/${documentId}/original`,
                  {
                    responseType:
                      "blob"
                  }
                )
              ]);


            if (!mounted) {
              return;
            }


            applyDocument(
              detailResponse
                .data
                .document
            );


            const nextUrl =
              window.URL
                .createObjectURL(
                  new Blob([
                    pdfResponse.data
                  ], {
                    type:
                      "application/pdf"
                  })
                );


            if (
              urlRef.current
            ) {

              window.URL
                .revokeObjectURL(
                  urlRef.current
                );
            }


            urlRef.current =
              nextUrl;

            setPdfUrl(
              nextUrl
            );

          } catch (err) {

            if (!mounted) {
              return;
            }


            setError(
              err?.response
                ?.data
                ?.message ||
              "Não foi possível abrir o documento."
            );

          } finally {

            if (mounted) {

              setLoading(
                false
              );
            }
          }
        };


      if (
        !Number.isInteger(
          documentId
        ) ||
        documentId <= 0
      ) {

        setError(
          "Documento inválido."
        );

        setLoading(
          false
        );

      } else {

        load();
      }


      return () => {

        mounted =
          false;


        if (
          urlRef.current
        ) {

          window.URL
            .revokeObjectURL(
              urlRef.current
            );

          urlRef.current =
            "";
        }
      };
    },
    [
      documentId,
      applyDocument
    ]
  );


  React.useEffect(
    () => {

      const recalculate =
        () => {

          const available =
            viewportRef
              .current
              ?.clientWidth ||
            820;


          setPageWidth(
            Math.max(
              280,
              Math.min(
                820,
                available - 34
              )
            )
          );
        };


      recalculate();


      window
        .addEventListener(
          "resize",
          recalculate
        );


      return () => {

        window
          .removeEventListener(
            "resize",
            recalculate
          );
      };
    },
    []
  );


  React.useEffect(
    () => {

      const handleMove =
        event => {

          const active =
            interactionRef
              .current;


          if (!active) {
            return;
          }


          event.preventDefault();


          const dx =
            (
              event.clientX -
              active.startX
            ) /
            pageWidth;

          const dy =
            (
              event.clientY -
              active.startY
            ) /
            (
              pageWidth *
              pageRatio
            );


          if (
            active.mode ===
            "drag"
          ) {

            setField({
              ...active.initial,

              x:
                clamp(
                  active.initial.x +
                    dx,
                  0,
                  1 -
                    active
                      .initial
                      .width
                ),

              y:
                clamp(
                  active.initial.y +
                    dy,
                  0,
                  1 -
                    active
                      .initial
                      .height
                )
            });

          } else {

            setField({
              ...active.initial,

              width:
                clamp(
                  active.initial.width +
                    dx,
                  0.10,
                  1 -
                    active
                      .initial
                      .x
                ),

              height:
                clamp(
                  active.initial.height +
                    dy,
                  0.035,
                  1 -
                    active
                      .initial
                      .y
                )
            });
          }


          setDirty(
            true
          );

          setSuccess("");
        };


      const handleUp =
        () => {

          interactionRef.current =
            null;
        };


      window
        .addEventListener(
          "pointermove",
          handleMove,
          {
            passive:
              false
          }
        );

      window
        .addEventListener(
          "pointerup",
          handleUp
        );

      window
        .addEventListener(
          "pointercancel",
          handleUp
        );


      return () => {

        window
          .removeEventListener(
            "pointermove",
            handleMove
          );

        window
          .removeEventListener(
            "pointerup",
            handleUp
          );

        window
          .removeEventListener(
            "pointercancel",
            handleUp
          );
      };
    },
    [
      pageWidth,
      pageRatio
    ]
  );


  const startInteraction =
    (
      mode,
      event
    ) => {

      event.preventDefault();


      interactionRef.current = {
        mode,

        startX:
          event.clientX,

        startY:
          event.clientY,

        initial: {
          ...field
        }
      };
    };


  const handleDocumentLoad =
    ({
      numPages: total
    }) => {

      setNumPages(
        total
      );


      setPageNumber(
        current =>
          clamp(
            current,
            1,
            total
          )
      );
    };


  const handlePageLoad =
    page => {

      const viewport =
        page.getViewport({
          scale: 1
        });


      if (
        viewport.width > 0
      ) {

        setPageRatio(
          viewport.height /
            viewport.width
        );
      }
    };


  const positionOnCurrentPage =
    () => {

      setField(
        current => ({
          ...current,
          page:
            pageNumber,
          x:
            0.17,
          y:
            0.77
        })
      );

      setDirty(
        true
      );

      setSuccess("");
    };


  const sendForSignature =
    async () => {

      setSending(
        true
      );

      setError("");

      setSuccess("");

      setSigningLink("");


      try {

        const response =
          await api.post(
            `/korax-sign/documents/${documentId}/send`
          );


        applyDocument(
          response
            .data
            .document
        );


        setSigningLink(
          response
            .data
            .signingUrl ||
          ""
        );


        setSuccess(
          response
            .data
            .emailSent
            ? "Link de assinatura enviado por e-mail."
            : response
                .data
                .warning ||
              "Link de assinatura criado."
        );

      } catch (err) {

        setError(
          err?.response
            ?.data
            ?.message ||
          "Não foi possível gerar o link de assinatura."
        );

      } finally {

        setSending(
          false
        );
      }
    };


  const copySigningLink =
    async () => {

      if (
        !signingLink
      ) {
        return;
      }


      try {

        await navigator
          .clipboard
          .writeText(
            signingLink
          );

        setSuccess(
          "Link de assinatura copiado."
        );

      } catch {

        setError(
          "Não foi possível copiar automaticamente. Selecione o link manualmente."
        );
      }
    };


  const save =
    async () => {

      setSaving(
        true
      );

      setError("");

      setSuccess("");


      try {

        const response =
          await api.put(
            `/korax-sign/documents/${documentId}/signature-field`,
            {
              fieldPage:
                field.page,

              fieldX:
                field.x,

              fieldY:
                field.y,

              fieldWidth:
                field.width,

              fieldHeight:
                field.height
            }
          );


        applyDocument(
          response
            .data
            .document
        );


        setDirty(
          false
        );

        setSuccess(
          "Posição da assinatura salva."
        );

      } catch (err) {

        setError(
          err?.response
            ?.data
            ?.message ||
          "Não foi possível salvar a posição da assinatura."
        );

      } finally {

        setSaving(
          false
        );
      }
    };


  if (loading) {

    return (

      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{
          minHeight:
            420
        }}
      >
        <CircularProgress
          size={30}
        />
      </Box>
    );
  }


  const signer =
    documentData
      ?.signers
      ?.[0];

  const pageHeight =
    pageWidth *
    pageRatio;

  const fieldOnThisPage =
    field.page ===
    pageNumber;


  return (

    <Box
      style={{
        padding:
          22,
        background:
          "#F8FAFC",
        minHeight:
          "calc(100vh - 64px)"
      }}
    >

      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        style={{
          gap:
            14,
          flexWrap:
            "wrap",
          marginBottom:
            16
        }}
      >

        <Box>

          <Button
            onClick={
              () => {
                window.location.href =
                  "/documents";
              }
            }
            style={{
              padding:
                0,
              minWidth:
                0,
              textTransform:
                "none",
              fontWeight:
                800,
              marginBottom:
                8
            }}
          >
            ← Voltar para documentos
          </Button>


          <Typography
            style={{
              fontSize:
                22,
              fontWeight:
                900,
              color:
                "#101828"
            }}
          >
            {
              documentData
                ?.title ||
              "Documento"
            }
          </Typography>


          <Typography
            style={{
              marginTop:
                4,
              fontSize:
                12,
              color:
                "#667085"
            }}
          >
            Posicione a área onde
            o signatário deverá assinar.
          </Typography>

        </Box>


        <Box
          display="flex"
          alignItems="center"
          style={{
            gap:
              10
          }}
        >

          <Chip
            label={
              documentData
                ?.status ===
              "READY"
                ? "Pronto para enviar"
                : documentData
                    ?.status ===
                  "SENT"
                  ? "Enviado"
                  : documentData
                      ?.status ===
                    "OPENED"
                    ? "Visualizado"
                    : "Rascunho"
            }
            style={{
              fontWeight:
                800,
              background:
                documentData
                  ?.status ===
                "READY"
                  ? "#ECFDF3"
                  : documentData
                      ?.status ===
                    "SENT"
                    ? "#EFF8FF"
                    : documentData
                        ?.status ===
                      "OPENED"
                      ? "#F4F3FF"
                      : "#F2F4F7",
              color:
                documentData
                  ?.status ===
                "READY"
                  ? "#027A48"
                  : documentData
                      ?.status ===
                    "SENT"
                    ? "#175CD3"
                    : documentData
                        ?.status ===
                      "OPENED"
                      ? "#6941C6"
                      : "#475467"
            }}
          />


          <Button
            variant="outlined"
            onClick={
              sendForSignature
            }
            disabled={
              sending ||
              saving ||
              savingSigner ||
              editingSigner ||
              Boolean(signer?.signedAt) ||
              signer?.status === "SIGNED" ||
              dirty ||
              ![
                "READY",
                "SENT",
                "OPENED"
              ].includes(
                documentData
                  ?.status
              )
            }
            style={{
              minWidth:
                190,
              height:
                40,
              borderRadius:
                9,
              textTransform:
                "none",
              fontWeight:
                850,
              borderColor:
                "#0057FF",
              color:
                "#0057FF"
            }}
          >
            {
              sending
                ? "Gerando..."
                : [
                    "SENT",
                    "OPENED"
                  ].includes(
                    documentData
                      ?.status
                  )
                  ? "Gerar novo link"
                  : "Enviar para assinatura"
            }
          </Button>


          <Button
            variant="contained"
            onClick={
              save
            }
            disabled={
              saving ||
              savingSigner ||
              editingSigner ||
              Boolean(signer?.signedAt) ||
              signer?.status === "SIGNED" ||
              !dirty
            }
            style={{
              minWidth:
                150,
              height:
                40,
              borderRadius:
                9,
              textTransform:
                "none",
              fontWeight:
                850,
              boxShadow:
                "none",
              background:
                "#0057FF",
              color:
                "#FFFFFF"
            }}
          >
            {
              saving
                ? "Salvando..."
                : "Salvar posição"
            }
          </Button>

        </Box>

      </Box>


      <Dialog
        open={editingSigner}
        onClose={() => {
          if (!savingSigner) setEditingSigner(false);
        }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Editar dados do signatário</DialogTitle>

        <DialogContent>
          <Box display="grid" style={{ gap: 14, paddingTop: 8 }}>
            <TextField
              label="Nome completo ou razão social"
              value={signerForm.name}
              onChange={e => setSignerForm({
                ...signerForm,
                name: e.target.value
              })}
              variant="outlined"
              size="small"
              fullWidth
            />

            <TextField
              label="E-mail"
              type="email"
              value={signerForm.email}
              onChange={e => setSignerForm({
                ...signerForm,
                email: e.target.value
              })}
              variant="outlined"
              size="small"
              fullWidth
            />

            <TextField
              label="WhatsApp"
              value={signerForm.phone}
              onChange={e => setSignerForm({
                ...signerForm,
                phone: e.target.value
              })}
              variant="outlined"
              size="small"
              fullWidth
            />

            <TextField
              select
              SelectProps={{ native: true }}
              label="Tipo de identificação"
              value={signerForm.identityType}
              onChange={e => setSignerForm({
                ...signerForm,
                identityType: e.target.value,
                identity: ""
              })}
              variant="outlined"
              size="small"
              fullWidth
            >
              <option value="CPF">CPF</option>
              <option value="CNPJ">CNPJ</option>
            </TextField>

            <TextField
              label={`Novo ${signerForm.identityType}`}
              value={signerForm.identity}
              onChange={e => setSignerForm({
                ...signerForm,
                identity: e.target.value
              })}
              helperText={
                "Deixe vazio para manter a identificação atual. " +
                "Para trocar CPF por CNPJ ou vice-versa, " +
                "informe o número completo."
              }
              variant="outlined"
              size="small"
              fullWidth
            />

            {["SENT", "OPENED"].includes(documentData?.status) && (
              <Typography style={{
                color: "#B54708",
                fontSize: 12
              }}>
                Após salvar, o link anterior será invalidado.
                Será necessário enviar um novo link de assinatura.
              </Typography>
            )}
          </Box>
        </DialogContent>

        <DialogActions style={{ padding: 20 }}>
          <Button
            onClick={() => setEditingSigner(false)}
            disabled={savingSigner}
          >
            Cancelar
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={saveSignerDetails}
            disabled={savingSigner}
            style={{
              background: "#0057FF",
              textTransform: "none"
            }}
          >
            {savingSigner ? "Salvando..." : "Salvar alterações"}
          </Button>
        </DialogActions>
      </Dialog>

      {error && (

        <Paper
          elevation={0}
          style={{
            padding:
              12,
            marginBottom:
              12,
            border:
              "1px solid #FDA29B",
            background:
              "#FFFBFA",
            borderRadius:
              9,
            color:
              "#B42318",
            fontSize:
              12.5
          }}
        >
          {error}
        </Paper>

      )}


      {success && (

        <Paper
          elevation={0}
          style={{
            padding:
              12,
            marginBottom:
              12,
            border:
              "1px solid #ABEFC6",
            background:
              "#ECFDF3",
            borderRadius:
              9,
            color:
              "#067647",
            fontSize:
              12.5
          }}
        >
          {success}
        </Paper>

      )}


      {signingLink && (

        <Paper
          elevation={0}
          style={{
            padding:
              14,
            marginBottom:
              12,
            border:
              "1px solid #B2CCFF",
            background:
              "#F5F8FF",
            borderRadius:
              10
          }}
        >

          <Typography
            style={{
              color:
                "#344054",
              fontSize:
                11,
              fontWeight:
                850,
              marginBottom:
                7
            }}
          >
            Link seguro
          </Typography>


          <Typography
            style={{
              color:
                "#475467",
              fontFamily:
                "monospace",
              fontSize:
                10.5,
              wordBreak:
                "break-all"
            }}
          >
            {signingLink}
          </Typography>


          <Button
            size="small"
            onClick={
              copySigningLink
            }
            style={{
              marginTop:
                9,
              padding:
                0,
              minWidth:
                0,
              textTransform:
                "none",
              fontWeight:
                850
            }}
          >
            Copiar link
          </Button>

        </Paper>

      )}


      <Box
        style={{
          display:
            "grid",
          gridTemplateColumns:
            "minmax(0, 1fr) 290px",
          gap:
            16,
          alignItems:
            "start"
        }}
      >

        <Paper
          elevation={0}
          style={{
            border:
              "1px solid #EAECF0",
            borderRadius:
              14,
            overflow:
              "hidden",
            background:
              "#EAECF0"
          }}
        >

          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            style={{
              padding:
                "10px 14px",
              background:
                "#FFFFFF",
              borderBottom:
                "1px solid #EAECF0",
              gap:
                10,
              flexWrap:
                "wrap"
            }}
          >

            <Button
              size="small"
              disabled={
                pageNumber <= 1
              }
              onClick={
                () =>
                  setPageNumber(
                    current =>
                      Math.max(
                        1,
                        current - 1
                      )
                  )
              }
              style={{
                textTransform:
                  "none",
                fontWeight:
                  800
              }}
            >
              ← Anterior
            </Button>


            <Typography
              style={{
                fontSize:
                  12,
                color:
                  "#475467",
                fontWeight:
                  800
              }}
            >
              Página {pageNumber}
              {
                numPages
                  ? ` de ${numPages}`
                  : ""
              }
            </Typography>


            <Button
              size="small"
              disabled={
                !numPages ||
                pageNumber >=
                  numPages
              }
              onClick={
                () =>
                  setPageNumber(
                    current =>
                      Math.min(
                        numPages,
                        current + 1
                      )
                  )
              }
              style={{
                textTransform:
                  "none",
                fontWeight:
                  800
              }}
            >
              Próxima →
            </Button>

          </Box>


          <Box
            ref={
              viewportRef
            }
            style={{
              overflow:
                "auto",
              padding:
                17,
              minHeight:
                620
            }}
          >

            {pdfUrl
              ? (

                <Box
                  style={{
                    position:
                      "relative",
                    width:
                      pageWidth,
                    height:
                      pageHeight,
                    margin:
                      "0 auto",
                    background:
                      "#FFFFFF",
                    boxShadow:
                      "0 2px 12px rgba(16,24,40,.13)"
                  }}
                >

                  <Document
                    file={
                      pdfUrl
                    }
                    onLoadSuccess={
                      handleDocumentLoad
                    }
                    loading={
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        style={{
                          height:
                            420
                        }}
                      >
                        <CircularProgress
                          size={28}
                        />
                      </Box>
                    }
                    onLoadError={
                      () =>
                        setError(
                          "Não foi possível renderizar este PDF."
                        )
                    }
                  >

                    <Page
                      pageNumber={
                        pageNumber
                      }
                      width={
                        pageWidth
                      }
                      renderTextLayer={
                        false
                      }
                      renderAnnotationLayer={
                        false
                      }
                      onLoadSuccess={
                        handlePageLoad
                      }
                    />

                  </Document>


                  {fieldOnThisPage && (

                    <Box
                      onPointerDown={
                        event =>
                          startInteraction(
                            "drag",
                            event
                          )
                      }
                      style={{
                        position:
                          "absolute",
                        left:
                          `${field.x * 100}%`,
                        top:
                          `${field.y * 100}%`,
                        width:
                          `${field.width * 100}%`,
                        height:
                          `${field.height * 100}%`,
                        minHeight:
                          34,
                        border:
                          "2px solid #0057FF",
                        borderRadius:
                          7,
                        background:
                          "rgba(0,87,255,.08)",
                        display:
                          "flex",
                        alignItems:
                          "center",
                        justifyContent:
                          "center",
                        cursor:
                          "move",
                        userSelect:
                          "none",
                        touchAction:
                          "none",
                        boxSizing:
                          "border-box",
                        zIndex:
                          5
                      }}
                    >

                      <Typography
                        style={{
                          fontSize:
                            11,
                          color:
                            "#0057FF",
                          fontWeight:
                            900,
                          textAlign:
                            "center",
                          pointerEvents:
                            "none",
                          padding:
                            "0 22px 0 8px"
                        }}
                      >
                        Assinatura de{" "}
                        {
                          signer
                            ?.name ||
                          "signatário"
                        }
                      </Typography>


                      <Box
                        onPointerDown={
                          event => {

                            event
                              .stopPropagation();

                            startInteraction(
                              "resize",
                              event
                            );
                          }
                        }
                        style={{
                          position:
                            "absolute",
                          right:
                            -2,
                          bottom:
                            -2,
                          width:
                            18,
                          height:
                            18,
                          borderRadius:
                            "6px 0 5px 0",
                          background:
                            "#0057FF",
                          cursor:
                            "nwse-resize",
                          touchAction:
                            "none"
                        }}
                      />

                    </Box>

                  )}

                </Box>

              )
              : null
            }

          </Box>

        </Paper>


        <Box
          style={{
            display:
              "grid",
            gap:
              12
          }}
        >

          <Paper
            elevation={0}
            style={{
              border:
                "1px solid #EAECF0",
              borderRadius:
                14,
              padding:
                16
            }}
          >

            <Typography
              style={{
                fontSize:
                  13,
                fontWeight:
                  900,
                color:
                  "#101828"
              }}
            >
              Signatário
            </Typography>

            {!signer?.signedAt &&
              signer?.status !== "SIGNED" &&
              !["COMPLETED", "CANCELLED"].includes(
                documentData?.status
              ) && (
                <Button
                  variant="outlined"
                  size="small"
                  onClick={openSignerEditor}
                  disabled={saving || sending || savingSigner}
                  style={{
                    marginTop: 12,
                    borderColor: "#0057FF",
                    color: "#0057FF",
                    textTransform: "none",
                    fontWeight: 800
                  }}
                >
                  Editar dados
                </Button>
              )}


            <Typography
              style={{
                marginTop:
                  12,
                fontSize:
                  12.5,
                fontWeight:
                  800,
                color:
                  "#344054"
              }}
            >
              {
                signer
                  ?.name ||
                "-"
              }
            </Typography>


            <Typography
              style={{
                marginTop:
                  3,
                fontSize:
                  11,
                color:
                  "#667085",
                wordBreak:
                  "break-word"
              }}
            >
              {
                signer
                  ?.email ||
                "-"
              }
            </Typography>


            <Typography
              style={{
                marginTop:
                  3,
                fontSize:
                  11,
                color:
                  "#667085"
              }}
            >
              {
                signer?.identityMasked ||
                signer?.cpfMasked ||
                "-"
              }
            </Typography>

          </Paper>


          <Paper
            elevation={0}
            style={{
              border:
                "1px solid #EAECF0",
              borderRadius:
                14,
              padding:
                16
            }}
          >

            <Typography
              style={{
                fontSize:
                  13,
                fontWeight:
                  900,
                color:
                  "#101828"
              }}
            >
              Área de assinatura
            </Typography>


            <Typography
              style={{
                marginTop:
                  8,
                fontSize:
                  11.5,
                lineHeight:
                  1.55,
                color:
                  "#667085"
              }}
            >
              Arraste a caixa azul
              para posicionar a assinatura.
              Use o canto inferior direito
              para redimensionar.
            </Typography>


            <Typography
              style={{
                marginTop:
                  10,
                fontSize:
                  11,
                color:
                  "#475467",
                fontWeight:
                  800
              }}
            >
              Posição atual: página{" "}
              {field.page}
            </Typography>


            {!fieldOnThisPage && (

              <Button
                fullWidth
                variant="outlined"
                onClick={
                  positionOnCurrentPage
                }
                style={{
                  marginTop:
                    12,
                  minHeight:
                    39,
                  borderRadius:
                    9,
                  textTransform:
                    "none",
                  fontWeight:
                    850
                }}
              >
                Posicionar nesta página
              </Button>

            )}

          </Paper>


          <Paper
            elevation={0}
            style={{
              border:
                "1px solid #EAECF0",
              borderRadius:
                14,
              padding:
                16
            }}
          >

            <Typography
              style={{
                fontSize:
                  12,
                fontWeight:
                  900,
                color:
                  "#344054"
              }}
            >
              Integridade
            </Typography>


            <Typography
              style={{
                marginTop:
                  8,
                fontFamily:
                  "monospace",
                fontSize:
                  10,
                color:
                  "#667085",
                wordBreak:
                  "break-all"
              }}
            >
              {
                documentData
                  ?.originalSha256 ||
                "-"
              }
            </Typography>

          </Paper>

        </Box>

      </Box>

    </Box>
  );
};


export default
  KoraxSignEditor;
